import * as React from "react";
import {
    List,
    Datagrid,
    TextField,
    Edit,
    Create,
    SimpleForm,
    TextInput,
    ReferenceInput,
    SelectInput,
    ReferenceField
} from 'react-admin';
import CustomTextInput from './components/CustomTextInput';
import { DefaultEditCreateActions, DefaultListActions, DefaultPagination } from '../lib/defaultConfig'

export const EmailTemplateList = props => (
    <List {...props} actions={<DefaultListActions />} pagination={<DefaultPagination />}>
        <Datagrid rowClick="edit">
            <TextField source="id" />
            <TextField source="title" />
            <ReferenceField source="systemEventTypeId" reference="system_event_type">
                <TextField source="title" />
            </ReferenceField>
        </Datagrid>
    </List>
);

const simpleForm =
    <SimpleForm>
        <TextInput source="title" fullWidth />
        <ReferenceInput source="systemEventTypeId" reference="system_event_type">
            <SelectInput optionText="title" />
        </ReferenceInput>
        <CustomTextInput source="content" fullWidth />
    </SimpleForm>

export const EmailTemplateEdit = props => (
    <Edit {...props} actions={<DefaultEditCreateActions />} mutationMode={'pessimistic'}>
        {simpleForm}
    </Edit>
);
export const EmailTemplateCreate = props => (
    <Create {...props} actions={<DefaultEditCreateActions />}>
        {simpleForm}
    </Create>
);
